import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Wrapper } from 'src/app/components/wrapper.component';
import { AddItemRowData, Budget, BudgetSection, SectionSettings } from '../../store/reselectors/budget.data';
import { JoiEvent } from 'globals/store/events.data';
import { BudgetSectionGridData, PaymentGridData } from '../../helpers/grid-helpers';
import { jsonCopyObject } from 'globals/helpers/helpers';
import { getGridDataFromSection, scheduleToScheduleGridData } from '../../store/reselectors/budget.reselector.helpers';
import { applyItemTemplateToLineItemInPlace } from '../../helpers/budget-helpers';
import { LineItemsDialogComponent, LineItemsDialogData } from './line-items.dialog.component';
import { LineItemTemplate } from 'globals/store/accounts.data';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { updateBudgetSectionInPlace } from 'globals/helpers/budget.helper';
import { BigDialogWrapperComponent } from 'src/app/components/wrappers/big-dialog-wrapper.component';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { BudgetSectionComponent } from './budget-section.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'add-budget-toggle-items',
    templateUrl: './add-budget-toggle-items.html',
    styleUrls: ['./add-budget-toggle-items.scss'],
    standalone: true,
    imports: [BigDialogWrapperComponent, TipTextComponent, BudgetSectionComponent, CommonModule],
})
export class AddBudgetToggleItemsDialogComponent extends Wrapper<AddBudgetToggleItemsDialogComponent>  {

  event: JoiEvent
  budget: Budget
  section: BudgetSection
  gridData: BudgetSectionGridData[]
  scheduleGridData: PaymentGridData[]
  toggleCount = 0
  hasChanged = false


  constructor(public dialogRef: MatDialogRef<AddBudgetToggleItemsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: AddBudgetToggleItemsData) {
    super()
    this.section = jsonCopyObject(data.section)
    this.setToggleCount()
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subCallback(this.store.select('budget', 'budget'), budget => {
      this.budget = budget
      this.setGridDatas()
    })
  }

  setToggleCount() {
    this.toggleCount = this.section.lineItems.filter(i => i.show).length
  }

  setGridDatas() {
    this.gridData = getGridDataFromSection(this.section, this.budget.currency)
    this.setToggleCount()
    if (this.section.schedule) this.scheduleGridData = scheduleToScheduleGridData(this.section.schedule, this.section.total)
  }

  async cancel() {
    this.dialogRef.close()
  }
  
  async save() {
    console.log("Shoud be saving...")
    const section = jsonCopyObject(this.section)
    section.lineItems = section.lineItems.filter(i => i.show)
    this.dialogRef.close(section)
  }

  async delete() {
    this.dialogRef.close({ delete: true })
  }

  updateSection() {
    updateBudgetSectionInPlace(this.section, this.budget.currency, true)
    this.section = jsonCopyObject(this.section)
    this.hasChanged = true
    this.setGridDatas()
    console.log("Should be updating section.")
  }

  saveSectionSettingDefaults(settings: Partial<SectionSettings>) {
    this.accountService.checkAndUpdateBudgetSectionSettingsDefaults(settings)
  }

  async addItem({ event, row }: AddItemRowData<BudgetSectionGridData>) {
    console.log("Should be adding item...", { event, row })
    const data: LineItemsDialogData = {
      x: event.x - 100,
      y: event.y + 27
    }
    const item = await openDialogGetResult<LineItemTemplate>(this.dialog, LineItemsDialogComponent, {
      width: '200px',
      autoFocus: false,
      data,
      disableClose: true,
    })
    if (item) {
      applyItemTemplateToLineItemInPlace(this.budget.currency, this.section, row.id, item, true)
      this.updateSection()
    }
  }
}

export interface AddBudgetToggleItemsData {
  section: BudgetSection
  isTasks?: boolean
}
